import { render, staticRenderFns } from "./ButtonCard.vue?vue&type=template&id=13b9e220&scoped=true&"
import script from "./ButtonCard.vue?vue&type=script&lang=js&"
export * from "./ButtonCard.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCard.vue?vue&type=style&index=0&id=13b9e220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9e220",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow})
